import Http, {UrlFull} from '../Http';

export const getFields = () =>
  Http.get(UrlFull + 'api/docs/campos/' + process.env.REACT_APP_ID_SUBTIPO);
